import { render, staticRenderFns } from "./table-prime-cell-image.vue?vue&type=template&id=6285c9d8&scoped=true"
import script from "./table-prime-cell-image.vue?vue&type=script&lang=js"
export * from "./table-prime-cell-image.vue?vue&type=script&lang=js"
import style0 from "./table-prime-cell-image.vue?vue&type=style&index=0&id=6285c9d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6285c9d8",
  null
  
)

export default component.exports